import React from 'react';

const ContentWrapper = ({ children }) => {
  return <div className={'contentWrapper'}>{children}</div>;
};

export default ContentWrapper;
